/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_No_DetailsInputs */

const th_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้จัดยังไม่ได้เพิ่มรายละเอียด`)
};

const en_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The organiser has not added any details yet.`)
};

const ja_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主催者はまだ詳細を追加していません。`)
};

const zh_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主办方尚未补充详情。`)
};

const es_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El organizador todavía no ha añadido detalles.`)
};

const pt_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O organizador ainda não adicionou detalhes.`)
};

const id_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyelenggara belum menambahkan detail.`)
};

const fr_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’organisateur n’a pas encore ajouté de détails.`)
};

const tl_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang idinagdag na detalye ang organizer.`)
};

const vi_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ban tổ chức chưa bổ sung chi tiết.`)
};

const ko_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주최자가 아직 상세 정보를 추가하지 않았습니다.`)
};

const de_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Veranstalter hat noch keine Details ergänzt.`)
};

const ru_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Организатор ещё не добавил подробностей.`)
};

const tr_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenleyen henüz ayrıntı eklemedi.`)
};

const it_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'organizzatore non ha ancora aggiunto dettagli.`)
};

const pl_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizator nie dodał jeszcze szczegółów.`)
};

const uk_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Організатор ще не додав подробиць.`)
};

const hi_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजक ने अभी विवरण नहीं जोड़ा है।`)
};

const ar_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يضف المنظّم تفاصيل بعد.`)
};

const ms_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penganjur belum menambah butiran.`)
};

const bn_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজক এখনও বিস্তারিত যোগ করেননি।`)
};

const zh_tw2_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主辦單位尚未補充細節。`)
};

const zh_hk2_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主辦單位尚未補充細節。`)
};

const ur_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتظم نے ابھی تفصیل شامل نہیں کی۔`)
};

const fa_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برگزارکننده هنوز جزئیاتی نیفزوده است.`)
};

const sw_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwandalizi hajaongeza maelezo bado.`)
};

const nl_event_no_details = /** @type {(inputs: Event_No_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De organisator heeft nog geen details toegevoegd.`)
};

/**
* | output |
* | --- |
* | "The organiser has not added any details yet." |
*
* @param {Event_No_DetailsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_no_details = /** @type {((inputs?: Event_No_DetailsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_No_DetailsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_no_details(inputs)
	if (locale === "ja") return ja_event_no_details(inputs)
	if (locale === "zh") return zh_event_no_details(inputs)
	if (locale === "es") return es_event_no_details(inputs)
	if (locale === "pt") return pt_event_no_details(inputs)
	if (locale === "id") return id_event_no_details(inputs)
	if (locale === "fr") return fr_event_no_details(inputs)
	if (locale === "tl") return tl_event_no_details(inputs)
	if (locale === "vi") return vi_event_no_details(inputs)
	if (locale === "ko") return ko_event_no_details(inputs)
	if (locale === "de") return de_event_no_details(inputs)
	if (locale === "ru") return ru_event_no_details(inputs)
	if (locale === "tr") return tr_event_no_details(inputs)
	if (locale === "it") return it_event_no_details(inputs)
	if (locale === "pl") return pl_event_no_details(inputs)
	if (locale === "uk") return uk_event_no_details(inputs)
	if (locale === "hi") return hi_event_no_details(inputs)
	if (locale === "ar") return ar_event_no_details(inputs)
	if (locale === "ms") return ms_event_no_details(inputs)
	if (locale === "bn") return bn_event_no_details(inputs)
	if (locale === "zh-TW") return zh_tw2_event_no_details(inputs)
	if (locale === "zh-HK") return zh_hk2_event_no_details(inputs)
	if (locale === "ur") return ur_event_no_details(inputs)
	if (locale === "fa") return fa_event_no_details(inputs)
	if (locale === "sw") return sw_event_no_details(inputs)
	if (locale === "nl") return nl_event_no_details(inputs)
	return en_event_no_details(inputs)
});